import http_request from '../http_request'
import config from 'config'

function getStudentsData(device_uid, rd, slide_id) {
	return http_request.get(`${config.api_hub}teacher/fill_the_blanks`)
		.send({
			device_uid,
			rd,
			slide_id,
		})
}

export {
	getStudentsData,
}
